<span
  class="icon-inline"
  v-tooltip.bottom="tooltipOptions"
>
  <component
    :is="svgComponent"
    :viewBox="viewBox"
    preserveAspectRatio="xMidYMid meet"
    :style="svgStyle"
  />
</span>
